import { createSelector } from 'reselect';
import { StoreState } from '../store-interfaces';

const templatesSelector = (state: StoreState) => state.adConfigs.adTemplates;

export const activeTemplatesSelector = createSelector(
  [templatesSelector],
  templates =>
    templates.filter(
      template => template.adConfig === null || template.adConfig.draft,
    ),
);

export const selectAdConfigs = (state: StoreState) =>
  state.adConfigs.entities || [];

export const selectMessengerAds = (state: StoreState) =>
  state.messengerAds.entities || [];

export const selectSyncedMessengerAds = createSelector(
  [selectMessengerAds],
  ads => ads.filter(ad => !ad.legacy),
);

export const selectLegacyMessengerAds = createSelector(
  [selectMessengerAds],
  ads => ads.filter(ad => ad.legacy),
);
